// API related actions
export const FETCHING_DEALERS_LIST = '@@toyota/FETCHING_DEALERS_LIST';
export const FETCHED_DEALERS_LIST = '@@toyota/FETCHED_DEALERS_LIST';
export const FETCHED_DEALERS_LIST_FAILED = '@@toyota/FETCHED_DEALERS_LIST_FAILED';
export const FETCHING_DEALER = '@@toyota/FETCHING_DEALER';
export const FETCHED_DEALER = '@@toyota/FETCHED_DEALER';
export const FETCHED_DEALER_FAILED = '@@toyota/FETCHED_DEALER_FAILED';
export const FETCHING_AGENCIES_BY_DEALER = '@@toyota/FETCHING_AGENCIES_BY_DEALER';
export const FETCHED_AGENCIES_BY_DEALER = '@@toyota/FETCHED_AGENCIES_BY_DEALER';
export const FETCHED_AGENCIES_BY_DEALER_FAILED = '@@toyota/FETCHED_AGENCIES_BY_DEALER_FAILED';
export const GET_ALL_AGENCIES_REQUEST = '@@toyota/GET_ALL_AGENCIES_REQUEST';
export const GET_ALL_AGENCIES_SUCCESS = '@@toyota/GET_ALL_AGENCIES_SUCCESS';
export const GET_ALL_AGENCIES_FAILED = '@@toyota/GET_ALL_AGENCIES_FAILED';
export const CHANGE_DEALERS_AGENCIES_FILTER = '@@toyota/CHANGE_DEALERS_AGENCIES_FILTER';
export const CLEAR_AGENCIES_LIST = '@@toyota/CLEAR_AGENCIES_LIST';
